import React from 'react';
import styles from './ToggleShowInCutaway.module.scss'
import { Switch, Icon, Typography } from 'antd';
import cn from 'classnames';

const { Text } = Typography;

export const ToggleShowInCutaway = ({ enabled, onChange }) => {
  return (
    <div className={cn(styles.root)}>
      <Switch
        checkedChildren={<Icon type="check" />}
        unCheckedChildren={<Icon type="close" />}
        checked={enabled}
        onChange={onChange}
      />
      <Text className={cn(styles.text, { [styles.active]: enabled })}>
        Показать план/факт
      </Text>
    </div>
  )
}